module.exports = __webpack_public_path__ + "static/media/Ooppah_Clube_Tia_Ge.a3d26e3e.pdf";